import React from "react";
import * as S from "./Dropdown.styles";

/**
 * Content component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown Content component
 */
export const Content = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof S.Content>
>(function Content({ children, ...props }, ref) {
  return (
    <S.Content ref={ref} {...props}>
      {children}
    </S.Content>
  );
});

/**
 * Label component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown Label component
 */
export const Label = (props: React.ComponentProps<typeof S.Label>) => (
  <S.Label {...props} />
);

/**
 * Separator component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown Separator component
 */
export const Separator = (props: React.ComponentProps<typeof S.Separator>) => (
  <S.Separator {...props} />
);

/**
 * FlatItem component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown FlatItem component
 */
export const FlatItem = (props: React.ComponentProps<typeof S.FlatItem>) => (
  <S.FlatItem {...props} />
);

/**
 * ItemLabel component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown ItemLabel component
 */
export const ItemLabel = (props: React.ComponentProps<typeof S.ItemLabel>) => (
  <S.ItemLabel {...props} />
);
